(function () {
  function initTableOfContents() {
    const toc = document.querySelector('.js-toc');
    const content = document.querySelector('.article__content');

    if (!content) return;

// 見出しの中身を自動的にspanで囲む
content.querySelectorAll('h2, h3, h4').forEach(function (heading) {
  if (heading.querySelector(':scope > .heading-marker__text')) return;

  const marker = document.createElement('span');
  marker.className = 'heading-marker__text';

  while (heading.firstChild) {
    marker.appendChild(heading.firstChild);
  }

  heading.appendChild(marker);
});

    if (!toc || !content) return;

    // 二重実行を防止
    if (toc.dataset.initialized === 'true') return;
    toc.dataset.initialized = 'true';

    const headings = content.querySelectorAll('h2, h3');

    if (!headings.length) {
      toc.remove();
      return;
    }

    const usedIds = new Set();

    headings.forEach(function (heading) {
      if (heading.id) {
        usedIds.add(heading.id);
      }
    });

    function slugify(text) {
      return text
        .trim()
        .toLowerCase()
        .replace(/[^\w\u3040-\u30ff\u3400-\u9fff]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    function createUniqueId(base) {
      let id = base;
      let number = 2;

      while (usedIds.has(id) || document.getElementById(id)) {
        id = base + '-' + number;
        number += 1;
      }

      usedIds.add(id);
      return id;
    }

    const list = document.createElement('ul');
    list.className = 'toc__list';

    headings.forEach(function (heading) {
      const text = (heading.textContent || '').trim();

      if (!text) return;

      if (!heading.id) {
        const base = slugify(text) || 'section';
        heading.id = createUniqueId(base);
      }

      const tagName = heading.tagName.toLowerCase();

      const item = document.createElement('li');
      item.className =
        'toc__item ' +
        (tagName === 'h3' ? 'toc__item--h3' : 'toc__item--h2');

      const link = document.createElement('a');
      link.className = 'toc__link';
      link.href = '#' + heading.id;
      link.textContent = text;

      link.addEventListener('click', function (event) {
        event.preventDefault();

        heading.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        history.replaceState(null, '', '#' + heading.id);
      });

      item.appendChild(link);
      list.appendChild(item);
    });

    // 有効な見出しがなければ目次ごと削除
    if (!list.children.length) {
      toc.remove();
      return;
    }

    toc.appendChild(list);

    // 目次を最初のH2直前へ移動
    const firstH2 = content.querySelector('h2');

    if (firstH2) {
      firstH2.before(toc);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTableOfContents);
  } else {
    initTableOfContents();
  }
})();